module.exports = __webpack_public_path__ + "img/Screenshot_20230817_124855_One UI Home~2.fd2c9e7a.jpg";